import { products } from './products';

export interface LayerConfig {
  id: string;
  layer: string;
  desc: string;
  products: typeof products;
}

export const layers: LayerConfig[] = [
  {
    id: 'strategic',
    layer: '战略引擎',
    desc: '确定性农业的顶层设计与战略决策中枢，为全局业务提供方向指引和生态协同支撑',
    products: products.filter((p) => p.category === 'strategic'),
  },
  {
    id: 'foundation',
    layer: '基础能力',
    desc: 'AI认知、知识管理与流量增长三大核心引擎，为上层应用提供智能化能力底座',
    products: products.filter((p) => p.category === 'foundation'),
  },
  {
    id: 'marketing',
    layer: '品牌营销',
    desc: '从品牌门户到获客转化的全链路营销矩阵，支撑陆渔科技面向客户的市场增长',
    products: products.filter((p) => p.category === 'marketing'),
  },
  {
    id: 'fishery',
    layer: '渔业领域',
    desc: '面向循环水养殖全场景的智能生产管控体系，覆盖规划、监测、运维到智能控制',
    products: products.filter((p) => p.category === 'fishery'),
  },
];